module.exports = __webpack_public_path__ + "img/07.37049630.jpg";